import { getOrganisationData, setOrganisationData } from 'service/storage';
import { CATCH_ERROR } from 'store/error/actions';
import {
  LOAD_ORGANISATION,
  SET_LOADED_ORGANISATION,
  UNLOAD_ORGANISATION,
  UNSET_LOADED_ORGANISATION,
} from 'store/organisations/actions';
import {
  selectIsOrganisationLoaded,
  selectOrganisationListItem,
} from 'store/organisations/selectors';
import { call, put, select, takeEvery } from 'typed-redux-saga';
import { Organisation } from './types';

function* upgradeOrganisationData(organisationData: Organisation) {
  const data = { ...organisationData };
  const upgraded = false;
  if (!data.dv) {
    data.dv = {};
  }
  // Do upgrades here
  if (upgraded) {
    yield* call(setOrganisationData, data.id, data);
  }
  return data;
}

function* loadOrganisationSaga(
  action: ReturnType<typeof LOAD_ORGANISATION.request>,
): Generator {
  try {
    const organisationListItem = yield* select(
      selectOrganisationListItem,
      action.payload,
    );
    if (!organisationListItem) {
      throw new Error('Organisation not found locally');
    }
    if (!(yield* select(selectIsOrganisationLoaded, action.payload))) {
      const organisationData = yield* call(getOrganisationData, action.payload);
      yield* put(
        SET_LOADED_ORGANISATION(
          yield* upgradeOrganisationData(organisationData),
        ),
      );
    }
    yield* put(LOAD_ORGANISATION.success(action.payload));
  } catch (error) {
    yield* put(LOAD_ORGANISATION.failure(action.payload));
    yield* put(CATCH_ERROR({ error }));
  }
}

function* unloadOrganisationSaga(
  action: ReturnType<typeof UNLOAD_ORGANISATION>,
): Generator {
  try {
    if (yield* select(selectIsOrganisationLoaded, action.payload)) {
      yield* put(UNSET_LOADED_ORGANISATION(action.payload));
    }
  } catch (error) {
    yield* put(CATCH_ERROR({ error }));
  }
}

export const organisationSideEffects = [
  takeEvery(LOAD_ORGANISATION.request, loadOrganisationSaga),
  takeEvery(UNLOAD_ORGANISATION, unloadOrganisationSaga),
];
